
@if (!config.isNativeControl) {
  <div [formGroup]="group"  class="{{ gs.isVersion2 ? '' : 'form-input' }} {{config.class}}" [hidden]="config.hide">
    @if (config.label && !config.appearanceOutline) {
      <div for="" class="default-sub-header text-label label-section">
        {{config.label | translate}} @if (config.isMandatory) {
        <span class="mandatory-field">*</span>
      }
      @if (config.icon) {
        <span class="view-icon" (click)="tooltip.toggle()" #tooltip="matTooltip" matTooltipPosition="right"  matTooltip="{{config.toolTip}}" class="{{config.icon}}"></span>
      }
    </div>
  }
  <mat-form-field  [ngClass]="{'input-with-boundary':config.appearance}" class="basic-select-dropdown" appearance="outline">
    @if (!config.icon && config.label && config.appearanceOutline) {
      <mat-label>{{config.label | translate}}</mat-label>
    }
    <mat-select [disabled]="config.disableSelect" (selectionChange)="selectedOption($event)" placeholder="{{config.placeholder | translate}}"  [formControlName]="config.name" [attr.name]="config.name" disableOptionCentering= 'true'
      [compareWith]="compareOptionValues"
      [aria-label]="config.ariaLabel ? (config.ariaLabel | translate) : null">
      <mat-select-trigger>
        @if (!config.isDateTime) {
          {{ config.options | memoize: group?.controls?.[config.name]?.value | translate }}
        }
        @if (config.isDateTime) {
          {{ config.options | memoize: group?.controls?.[config.name]?.value | localizeDate: 'LT' }}
        }
      </mat-select-trigger>
      @for (option of config.options; track option) {
        <mat-option [value]="option.id" [attr.aria-label]="config.ariaLabel">
          @if (!config.isDateTime) {
            <span matTooltipClass="tooltip-class" title="{{option.value | translate}}">{{ option.value | translate  }}</span>
          }
          @if (config.isDateTime) {
            <span matTooltipClass="tooltip-class" title="{{option.value | localizeDate: 'LT'}}">{{ option.value | localizeDate: 'LT' }}</span>
          }
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
}
@if (config.isNativeControl) {
  <div [formGroup]="group"  class="{{ gs.isVersion2 ? '' : 'form-input' }} {{config.class}}" [hidden]="config.hide">
    <div class="alt-theme-scope">
      @if (config.label) {
        <div for="" class="default-sub-header text-label label-section">
          {{config.label | translate}}
          @if (config.icon) {
            <span class="view-icon" (click)="tooltip.toggle()" #tooltip="matTooltip" matTooltipPosition="right"  matTooltip="{{config.toolTip}}" class="{{config.icon}}"></span>
          }
        </div>
      }
      <mat-form-field  [ngClass]="{'input-with-boundary':config.appearance}" class="basic-select-dropdown" appearance="outline">
        <select [disabled]="config.disableSelect" (change)="selectedOption($event)" placeholder="{{config.placeholder | translate}}"  [formControlName]="config.name" [attr.name]="config.name" disableOptionCentering='true' matNativeControl
          [attr.aria-label]="config.ariaLabel ? (config.ariaLabel | translate) : null">
          @for (option of config.options; track option) {
            <option [value]="option.id">
              @if (!config.isDateTime) {
                {{ option.value | translate }}
              }
              @if (config.isDateTime) {
                {{ option.value | localizeDate: 'LT' }}
              }
            </option>
          }
        </select>
      </mat-form-field>
    </div>
  </div>
}

